import { FormControlLabel, FormLabel, Radio, RadioGroup, TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputBasic from "../../ProfilesComp/InputsBasic";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const RowTableFinancial = ({index, fieldV, Translation, updateTableFinancial}) =>{
    const { t } = useTranslation();
    const [financialData, setFinancialData] = useState({
        "Status": "",
        "NeedHelpApplying": ""
    });

    const storedData = useSelector(state => state.profiles.FinancialResources);

    useEffect(() => {
        setFinancialData(() => ({
            ...storedData[fieldV]
        }));
    }, [storedData]);

    const handleChange = async(field, value) => {
        setFinancialData((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };
    const handleNextStepRow = async (field, value) => {
        await handleChange(field, value);
    };

    useEffect(() => {
        updateTableFinancial({ fieldV, financialData });
    }, [financialData]);
    
    return(
        <TableRow key={index}>
            <TableCell><FormLabel component="legend">{t(Translation)}</FormLabel></TableCell>
            <TableCell>
                <RadioGroup
                    value={financialData.Status}
                    onChange={(e) => handleNextStepRow("Status", e.target.value)}
                >
                    <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
                    <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
                    <FormControlLabel value="pending" control={<Radio />} label={t("Profiles.FinancialResources.pending")} />
                </RadioGroup>
            </TableCell>
            <TableCell>
                <InputBasic 
                    value={financialData.NeedHelpApplying || ""}  
                    onChange={(e) => handleNextStepRow("NeedHelpApplying", e.target.value)}
                />
            </TableCell>
        </TableRow>
    )
}
export default RowTableFinancial;